"use client";

import React from "react";
import { ArrowRight, Flame, Utensils, Hammer } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tabFeatures = [{
  id: "fireplaces",
  label: "Fireplaces",
  icon: Flame,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/stone_fireplace_interior.png",
  alt: "Custom stone fireplace interior design"
}, {
  id: "cooking-areas",
  label: "Cooking Areas",
  icon: Utensils,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/outdoor_kitchen_masonry.png",
  alt: "Outdoor masonry cooking area and grill"
}, {
  id: "custom-finishes",
  label: "Custom Finishes",
  icon: Hammer,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/masonry_detail_work.png",
  alt: "Detailed masonry finishes and textures"
}];
export default function OperationalExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224671" id="fireplaces-outdoor-living" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="flex flex-col space-y-8 lg:order-1">
            <div className="space-y-6">
              <div className="inline-block bg-primary px-4 py-1 rounded-none">
                <span className="font-default text-xs font-bold uppercase tracking-widest text-primary-foreground">
                  Featured Service
                </span>
              </div>
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-normal uppercase tracking-wider text-foreground leading-[1.1]">
                Fireplaces & <br className="hidden lg:block" />
                <span className="text-primary">Outdoor Living</span>
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl font-sans">
                We specialize in crafting stunning fireplaces and outdoor cooking areas that blend beauty with functionality. From traditional brick and stone designs to modern finishes, we tailor each space to suit your style and enhance your home's comfort and value.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/HomePage">
                <Button size="lg" className="w-full sm:w-auto uppercase tracking-widest font-default rounded-full bg-primary hover:bg-primary/90 text-primary-foreground transition-colors duration-300">
                  Get a Quote
                  <ArrowRight className="ml-2 size-4" />
                </Button>
              </Link>
            </div>
          </div>

          <div className="w-full lg:order-2">
            <Tabs defaultValue={tabFeatures[0].id} className="w-full flex flex-col gap-6">
              <TabsList className="w-full flex justify-start overflow-x-auto no-scrollbar bg-muted/30 p-1 rounded-none border border-border">
                {tabFeatures.map((tab, i) => {
                const Icon = tab.icon;
                return <TabsTrigger key={tab.id} value={tab.id} data-index={i} className="flex-1 min-w-[140px] py-2.5 text-sm uppercase tracking-widest font-default data-[state=active]:bg-primary data-[state=active]:text-primary-foreground rounded-none transition-all">
                      <Icon className="mr-2 size-4" />
                      {tab.label}
                    </TabsTrigger>;
              })}
              </TabsList>

              <div className="relative rounded-none overflow-hidden border border-border shadow-none bg-card">
                {tabFeatures.map((tab, i) => <TabsContent key={tab.id} value={tab.id} data-index={i} className="m-0 focus-visible:outline-none focus-visible:ring-0">
                    <AspectRatio ratio={16 / 9}>
                      <div className="absolute inset-0 bg-muted animate-pulse" />
                      <img src={tab.image} alt={tab.alt} className="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500" loading="lazy" />
                      <div className="absolute inset-0 pointer-events-none border border-white/5 mix-blend-overlay" />
                    </AspectRatio>
                  </TabsContent>)}
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </section>;
}